var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.384422 0.384422C0.896985 -0.128141 1.72801 -0.128141 2.24058 0.384422L19.7406 17.8844C20.2531 18.397 20.2531 19.228 19.7406 19.7406C19.228 20.2531 18.397 20.2531 17.8844 19.7406L0.384422 2.24058C-0.128141 1.72801 -0.128141 0.896985 0.384422 0.384422Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7406 0.384422C20.2531 0.896985 20.2531 1.72801 19.7406 2.24058L2.24058 19.7406C1.72801 20.2531 0.896985 20.2531 0.384422 19.7406C-0.128141 19.228 -0.128141 18.397 0.384422 17.8844L17.8844 0.384422C18.397 -0.128141 19.228 -0.128141 19.7406 0.384422Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.46064dcf690969abcca748a8bf3faad3.svg";
export { ForwardRef as ReactComponent };